import React from 'react';
import Warning from '../../assets/WarningIcon';
import styledComponent from '../../utils/styledComponent';

const AlertBoxWrapper = styledComponent('section', {
  '& header': {
    alignItems: 'center',
    background: '#d0021b',
    color: '#FFFFFF',
    display: 'flex',
    fontSize: '24px',
    padding: '16px',
  },
  '& .childrenContent': {
    fontSize: '18px',
    lineHeight: '140%',
    color: '#2c2d31',
    padding: '16px',
    letterSpacing: '0',
  },
  '& ul': {
    margin: '0px',
    paddingLeft: '20px',
  },
  '& li': {
    marginBottom: '8px',
  },
  '& svg': {
    fill: '#FFFFFF',
    height: '30px',
    marginRight: '16px',
  },
  border: `3px solid #d0021b`,
  color: '#d0021b',
  fontSize: '16px',
  marginBottom: '32px',
  minWidth: '700px',
  width: '100%',
  letterSpacing: '0.6px',
  boxSizing: 'border-box',
});

const AlertBox = ({ title, children }) => (
  <AlertBoxWrapper>
    <header>
      <Warning color="#FFFFFF" />
      {title}
    </header>
    <div className="childrenContent">{children}</div>
  </AlertBoxWrapper>
);

export default AlertBox;
